// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Mono&family=Libre+Baskerville&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --app-font-family: 'Roboto Mono', Monaco, monospace; */

:root {
  /* Move these variables to a separate theme file if you want to switch themes */
  --primary-color: #002475;
  --background-color: #f0f0f0;
  --text-color: #333;
  --border-color: #002475;
  --card-background-color: white;
  --logo-font-family: 'Libre Baskerville', serif;
  --app-font-family: 'Roboto Mono', monospace;
}


body,
input,
button,
select,
textarea {
  font-family: var(--app-font-family) !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100vh;
  background-color: white;
}

code {
  font-family: var(--app-font-family) !important;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin: 1rem 0;
}

.stat-card {
  background: #ffffff;
  border: 1px solid black;
  padding: 1rem;
  text-align: center;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.stat-value {
  color: #002475;
  font-size: 1.5rem;
  font-weight: bold;
}

.stat-subtitle {
  color: #888;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}

.chart-section {
  margin: 2rem 0;
}

.chart-title {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.custom-tooltip {
  background: white;
  border: 1px solid #e0e0e0;
  padding: 0.5rem;
  border-radius: 4px;
}

.stats-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.chart-section:last-child .stats-row {
  grid-template-columns: repeat(2, 1fr);
}

.stat-card {
  background: #ffffff;
  border: 1px solid black;
  padding: 1rem;
  text-align: center;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.stat-value {
  color: #002475;
  font-size: 1.5rem;
  font-weight: bold;
}

.charts-row {
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
}

.half-width {
  width: 50%;
}

.hyperliquid-link {
  background-color: #002475;
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s ease, color 0.3s ease;
  margin-left: 20px;
}

.hyperliquid-link:hover {
  background-color: white;
  color: #002475;
  border: 1px solid #002475;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA,yDAAyD;;AAEzD;EACE,+EAA+E;EAC/E,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,8CAA8C;EAC9C,2CAA2C;AAC7C;;;AAGA;;;;;EAKE,8CAA8C;EAC9C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,uDAAuD;EACvD,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono&family=Libre+Baskerville&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400;500;700&display=swap');\n\n/* --app-font-family: 'Roboto Mono', Monaco, monospace; */\n\n:root {\n  /* Move these variables to a separate theme file if you want to switch themes */\n  --primary-color: #002475;\n  --background-color: #f0f0f0;\n  --text-color: #333;\n  --border-color: #002475;\n  --card-background-color: white;\n  --logo-font-family: 'Libre Baskerville', serif;\n  --app-font-family: 'Roboto Mono', monospace;\n}\n\n\nbody,\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: var(--app-font-family) !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  min-height: 100vh;\n  background-color: white;\n}\n\ncode {\n  font-family: var(--app-font-family) !important;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin: 1rem 0;\n}\n\n.stat-card {\n  background: #ffffff;\n  border: 1px solid black;\n  padding: 1rem;\n  text-align: center;\n}\n\n.stat-label {\n  color: #666;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n.stat-value {\n  color: #002475;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.stat-subtitle {\n  color: #888;\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n}\n\n.chart-section {\n  margin: 2rem 0;\n}\n\n.chart-title {\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.2rem;\n}\n\n.custom-tooltip {\n  background: white;\n  border: 1px solid #e0e0e0;\n  padding: 0.5rem;\n  border-radius: 4px;\n}\n\n.stats-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin: 1rem 0;\n}\n\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.chart-section:last-child .stats-row {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.stat-card {\n  background: #ffffff;\n  border: 1px solid black;\n  padding: 1rem;\n  text-align: center;\n}\n\n.stat-label {\n  color: #666;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n.stat-value {\n  color: #002475;\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.charts-row {\n  display: flex;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.half-width {\n  width: 50%;\n}\n\n.hyperliquid-link {\n  background-color: #002475;\n  color: white;\n  padding: 10px 15px;\n  border-radius: 5px;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: bold;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  margin-left: 20px;\n}\n\n.hyperliquid-link:hover {\n  background-color: white;\n  color: #002475;\n  border: 1px solid #002475;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
